import { render, staticRenderFns } from "./updata-upgrade-pack.vue?vue&type=template&id=e1188e52"
import script from "./updata-upgrade-pack.vue?vue&type=script&lang=ts"
export * from "./updata-upgrade-pack.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports